<mat-spinner *ngIf="isLoadingProjectsList" [diameter]="11"></mat-spinner>
<span *ngIf="!utilService.isNullOrUndefined(projects)">
	<span
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		*ngIf="projects.length > 0"
		[mtxPopoverTriggerFor]="projectsPopover"
		class="cursor-pointer"
		mtxPopoverTriggerOn="click"
	>
		<span
			*ngIf="!utilService.isNullOrUndefined(selectedProject)"
			class="font-size-18"
			fxLayoutAlign="center center"
		>
			<span>{{ selectedProject.name }}</span>
		</span>
		<span
			*ngIf="utilService.isNullOrUndefined(selectedProject)"
			class="font-size-18"
			fxLayoutAlign="{{ labelAlignment }}"
		>
			<span>Select Project</span>
			<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">keyboard_arrow_down</mat-icon>
		</span>
		<mat-icon
			(click)="$event.stopPropagation(); projectCleared()"
			*ngIf="!utilService.isNullOrUndefined(selectedProject)"
			class="danger-text cursor-pointer m-l-1"
			fxFlex="10"
			fxLayoutAlign="end end"
		>
			close
		</mat-icon>
	</span>

	<mtx-popover #projectsPopover="mtxPopover" (close)="page = 0" [closeOnPanelClick]="false">
		<mat-card>
			<mat-card-header>
				<mat-form-field fxFlex="80">
					<input
						[(ngModel)]="searchText"
						autocomplete="off"
						matInput
						placeholder="Type to filter"
					/>
				</mat-form-field>
			</mat-card-header>

			<mat-card-content class="projects-dropdown">
				<div
					*ngFor="let project of projects | search: 'name':searchText"
					class="padding-0-5"
					fxLayout="row"
				>
					<div
						(click)="projectSelected(project)"
						class="primary-text font-size-vw cursor-pointer"
						fxFlex
						fxLayoutAlign="center center"
					>
						{{ project.name }}
					</div>
				</div>
			</mat-card-content>
			<mat-divider *ngIf="hasNextPage"></mat-divider>

			<mat-card-actions *ngIf="hasNextPage" fxLayoutAlign="end center">
				<span
					(click)="viewMoreProjects()"
					*ngIf="!isLoadingProjectsList"
					class="text-underline primary-text cursor-pointer"
					>View More</span
				>
				<mat-spinner *ngIf="isLoadingProjectsList" [diameter]="30"></mat-spinner>
			</mat-card-actions>
		</mat-card>
	</mtx-popover>
</span>
